var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 303.15 33.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05E2\\u05DE\\u05D5\\u05D3_\\u05D4\\u05D1\\u05D9\\u05EA_\\u05D4\\u05D8\\u05E8\\u05E0\\u05E1\\u05D9",
    "data-name": "\\u05E2\\u05DE\\u05D5\\u05D3 \\u05D4\\u05D1\\u05D9\\u05EA \\u05D4\\u05D8\\u05E8\\u05E0\\u05E1\\u05D9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.29,12.36h-7.28v20.07H0v-8.13h4.79v-11.94H1.41V4.23h29.09v28.2h-9.21V12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.28,4.23h9.21v28.2h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.48,24.3V4.23h9.16l.05,28.2h-16.45v-8.13h7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.47,4.23h9.21v28.2h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.35,32.43h-9.21v-14.1c0-8.74,6.49-15.04,15.32-15.04s15.18,6.3,15.18,15.04c0,12.31-9.12,17.25-18.99,13.49l2.26-7.57c3.9,1.5,7.52-.23,7.52-5.92,0-3.85-2.54-6.58-5.97-6.58s-6.11,2.73-6.11,6.58v14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.23,12.36h-7.28v20.07h-14v-8.13h4.79v-11.94h-3.38V4.23h29.09v28.2h-9.21V12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.99,12.36h-7.28v20.07h-14v-8.13h4.79v-11.94h-3.38V4.23h29.09v28.2h-9.21V12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.74,4.23h9.21v15.51h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.99,4.23h9.21v15.51h-9.21V4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.87,12.36h-13.02V4.23h22.23v28.2h-9.21V12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.73,0h9.21v4.23h15.79l-12.17,29.14-8.41-3.43,7.43-17.58h-11.84V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.94,27.35h-3.57v5.08h-8.32v-13.21h11.89V4.23h9.21v28.2h-9.21v-5.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/גלריית תמונותmdpi.5669f982949ebdf04ff18ea83dd2cd30.svg";
export { ForwardRef as ReactComponent };